const doc = [({"en":({"adminConstantHotelChildrenSearchDisplayType":({"all":"All", "onlyAge":"Only age", "onlyMealTypeAndBedding":"Only meal and bedding"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;